<template>
  <section class="archives-panel">
    <main class="main">
      <table>
        <colgroup>
          <col style="width: 25px;" ></col>
        </colgroup>
        <thead>
          <tr>
            <th @click="onSort('archive')" class="clickable">Archief</th>
            <th @click="onSort('deleteditems')" class="align-right clickable">
              Items
            </th>
          </tr>
        </thead>
        <tbody>
          <pre-loader
            message="De prullenmand wordt geladen."
            v-if="loading"
          ></pre-loader>
          <p
            class="placeholder empty-text"
            v-if="!loading && archives.length < 1"
          >
            De prullenmand is leeg
          </p>
          <tr
            v-for="(archive, index) in displayArchives"
            :key="index"
            @click="goToTrash(archive.id)"
          >
            <td>
              {{ archive.archive }}
            </td>
            <td class="align-right">{{ archive.deleteditems }}</td>
          </tr>
        </tbody>
      </table>
    </main>
  </section>
</template>
<script>
import FileNavigationMixin from '@/features/filestore/FileNavigationMixin.js'
import ArchiveUsersMixin from '@/features/filestore/ArchiveUsersMixin'
import { trashGetArchives } from '@/features/filestore/FileStoreApi'
import PreLoader from '@/components/ui/PreLoader'
import SortMixin from '@/mixins/SortMixin'

export default {
  components: { PreLoader },
  mixins: [FileNavigationMixin, ArchiveUsersMixin, SortMixin],
  data() {
    return {
      loading: true,
      archives: []
    }
  },
  created() {
    trashGetArchives().then((archives) => {
      this.archives = archives.filter((archive) => archive.deleteditems > 0)
      this.loading = false
    })
  },
  computed: {
    displayArchives() {
      return this.sortArray(this.archives)
    }
  },
  methods: {
    goToTrash(folderId) {
      this.$router.push({
        name: 'fileStoreTrash',
        params: { folderId: folderId }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.archives-panel {
  display: grid;
  grid-template-rows: auto 70px;
  height: 100%;
  .main {
    overflow: auto;
  }
}

.main-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* Make content look like it is centered vertically */
  margin-bottom: 50px;
}

table {
  width: 100%;
  border-collapse: collapse;
  color: var(--text-color);

  thead {
    border-bottom: solid 1px #e6e6e6;

    tr {
      height: 38px;

      th:first-child {
        padding-left: 20px;
      }

      th:last-child {
        padding-right: 20px;
      }

      th {
        text-align: left;
        vertical-align: middle;
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }

  tbody {
    tr:first-child {
      height: 49px;
    }
    tr {
      cursor: pointer;
      transition: background-color 0.6s;

      &.folder {
        font-weight: 600;
      }

      &:hover {
        background-color: var(--hover-color);
      }

      td:first-child {
        padding-left: 20px;
      }

      td:last-child {
        padding-right: 20px;
      }

      td {
        height: 48px;
        vertical-align: middle;
        //padding-top: 12px;
        padding-left: 5px;
        padding-right: 5px;
        font-weight: 600;
      }
    }
  }
}

.empty-text {
  padding: 20px 0 0 12px;
  width: 190px;
}
</style>
